import { ParsedUrlQuery } from 'querystring';
import { CheckoutSchemaFields } from 'src/schemas/CheckoutSchema';
import { OrderCreationType, OrderType, OrderUpdateType } from 'src/types';

import { formatBirthdate } from 'src/utils/date';
import { normalizePhoneFromInput } from 'src/utils/phone';

type SerializeParams = CheckoutSchemaFields & {
  contractId: string;
  queryParams: ParsedUrlQuery;
  offerId: string;
  orderId?: string;
  captchaToken: string;
};

export const CheckoutSerializer = {
  serialize: (data: SerializeParams): OrderCreationType | OrderUpdateType => {
    const baseSerializedData = {
      id: data.orderId,
      contractId: data.contractId,
      offerId: data.offerId,
      email: data.email,
      phone: normalizePhoneFromInput(data.phone),
      customerName: data.name,
      customerBirthdate: data.birthdate,
      customerDocument: data.cpf,
      captchaToken: data.captchaToken,
    };

    if (!data.orderId) baseSerializedData['queryParams'] = data.queryParams;
    if (!data.zipCode) return baseSerializedData;

    return {
      ...baseSerializedData,
      address: {
        cityId: data.cityId,
        zipcode: data.zipCode,
        street: data.street,
        neighborhood: data.neighborhood,
        number: data.number,
        complement: data.complement,
      },
    };
  },
  serializeToForm: (order: OrderType): CheckoutSchemaFields => {
    if (!order) return {};

    const personalData = {
      name: order.customerName,
      cpf: order.customerDocument,
      birthdate: formatBirthdate(order.customerBirthdate),
      phone: order.phone.address,
      email: order.email.address,
      accept: true,
    };

    if (!order.address) return personalData;

    const { zipcode } = order.address;

    return {
      ...personalData,
      zipCode: `${zipcode.slice(0, 5)}-${zipcode.slice(5, 8)}`,
      number: order.address.number,
      complement: order.address.complement || '',
      cityId: order.address.city.id,
      stateId: order.address.city.state.id,
      neighborhood: order.address.neighborhood,
      street: order.address.street,
    };
  },
};
